module.exports = __webpack_public_path__ + "img/59_23.6fc7e57f.png";